import * as z from "zod";

export const testWooCommerceConnection = {
  name: "testWooCommerceConnection" as const,
  input: z.object({
    shopUrl: z.string().optional(),
    consumerKey: z.string().optional(),
    consumerSecret: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), message: z.string() }),
};
